@import "../smart-country-selector/uiaas-smart-country-selector-banner.scss";

.item-header {
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
  margin-bottom: 20px;

  @media (max-width: $uiaas-tablet) {
    flex: auto;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  &__title {
    margin: 0;
  }
}

[dir="rtl"] .item-header__title {
  @media (min-width: $uiaas-tablet) {
    margin-right: 20px;
  }
}

.smart-country-selector-banner-content__icon[dir="rtl"] {
  margin-right: 0;
  margin-left: 12px;
}

.smart-country-selector-banner--srp-variant {
  @media (max-width: $tablet) {
    margin-top: 0;
  }
}

.smart-country-selector-banner-content p {
  @media (max-width: $tablet) {
    font-size: 22px;
    line-height: 30px;
  }
}
